module.exports = __webpack_public_path__ + "static/media/sms-initial-reminder.04a47670.png";